
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { RecadoDto } from "app/models/recado-dto.model";
import { Observable } from "rxjs";

export abstract class AbRecado extends AppService {
  abstract user: any;
  abstract getAllRecados(filter: AppFilter): Observable<any>;
  abstract getAllRecadosByPessoa(filter: AppFilter): Observable<any>;
  abstract saveRecado(recado: RecadoDto): Observable<any>;
  abstract getComunicado(recado: RecadoDto): Observable<any>;
  abstract uploadAnexo(recadoId: number, anexos): Observable<any>;
  abstract deletar(id: number);
  abstract getAllRecadoPessoa(filter: AppFilter): Observable<any>;
  abstract getVisualizacoes(recadoId: number): Observable<any>;
  abstract isIntegrador(): Boolean;

}